import * as React            from 'react';

import cc                    from 'classcat';

import { Container,
         Control,
         LabelText,
         LabelLink,
         CheckboxVariants,
         checkbox_variants } from 'src/components/common/checkbox/ui';



type Props = {
  variant: CheckboxVariants;
  value: boolean;
  label?: string;
  url?: string;
  isDisabled?: boolean;
  onChange: (value: boolean) => void;
}
export const Checkbox: React.FC<Props> = ({
  variant,
  value,
  label,
  url,
  isDisabled = false,
  onChange,
}) => {
  const lookAndFeel = checkbox_variants.get(variant)!;

  const onClickHandler = () => {
    if (!isDisabled)
    {
      onChange(!value);
    }
  }

  return (
    <Container lookAndFeel = { lookAndFeel }>
      <Control lookAndFeel = { lookAndFeel } className = { cc({ checked: value, disabled: isDisabled }) } onClick = { onClickHandler }>
        <svg width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
          <path
            fill = 'white'
            stroke = 'white'
            strokeWidth = '0.4'
            d = 'M15.6045 4.98242C15.7583 4.83841 15.9976 4.83833 16.1514 4.98242L16.9814 5.75977C17.1498 5.91784 17.15 6.18581 16.9814 6.34375L7.72266 15.0176C7.56882 15.1617 7.32962 15.1617 7.17578 15.0176L3.01953 11.124C2.85045 10.9656 2.85088 10.6969 3.02051 10.5391L3.85742 9.76074C4.01137 9.61762 4.24991 9.61799 4.40332 9.76172L7.44922 12.6152L15.6045 4.98242Z' 
          />
        </svg>
      </Control>
      { label !== undefined && url === undefined &&
        <LabelText lookAndFeel = { lookAndFeel }>
          { label }
        </LabelText>
      }
      { url !== undefined &&
        <LabelLink lookAndFeel = { lookAndFeel } target = '_blank' href = { url }>
          { label }
        </LabelLink>
      }
    </Container>
  );
};
